/**
 * Styling for a *nested* tab strip.
 *
 * Underlined rather than the filled pills of the section tabs above, so two
 * stacked TabsLists read as two levels instead of one control repeated. Used by
 * the Xero pipeline console and by Users → Analytics; keeping one definition
 * means a change to the nested-tab look lands in both.
 *
 * Applied as `className` on the shadcn `TabsList` / `TabsTrigger`, so Radix
 * keeps supplying roving focus, arrow-key movement and the tab/tabpanel wiring.
 */

export const SUB_TAB_LIST =
  "mb-4 h-auto w-full justify-start gap-5 rounded-none border-b border-border bg-transparent p-0";

export const SUB_TAB_TRIGGER =
  "rounded-none border-b-2 border-transparent bg-transparent px-1 pb-2 pt-0 text-sm font-medium text-muted-foreground shadow-none data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-foreground data-[state=active]:shadow-none";
